export default "__VITE_ASSET__swLi3Xip__"